class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  // onFormReset(event) {
  //   // Prevent default so the form reset doesn't set the value gotten from the url on page load
  //   event.preventDefault();
  //   // Don't reset if the user has selected an element on the predictive search dropdown
  //   if (this.shouldResetForm()) {
  //     this.input.value = '';
  //     this.input.focus();
  //     this.toggleResetButton();
  //   }
  // }

  // tt-custom-search-bar code
  onFormReset(event) {
  event.preventDefault();

  if (!this.shouldResetForm()) return;

  const predictiveSearch = this.closest('predictive-search');

  // Clear input FIRST
  this.input.value = '';
  this.toggleResetButton();

  if (predictiveSearch) {
    // Fully reset predictive search state
    predictiveSearch.searchTerm = '';
    predictiveSearch.abortController.abort();
    predictiveSearch.abortController = new AbortController();

    predictiveSearch.removeAttribute('open');
    predictiveSearch.removeAttribute('results');
    predictiveSearch.removeAttribute('loading');

    // Clear rendered markup (includes "Search for ..." button)
    const results = predictiveSearch.querySelector('[data-predictive-search]');
    if (results) results.innerHTML = '';

    const searchForButton = predictiveSearch.querySelector('#predictive-search-option-search-keywords');
    if (searchForButton) searchForButton.remove();
  }

  // Optional: keep cursor UX consistent
  this.input.blur();
  this.input.focus();
}
  //tt-custom-search-bar code end
}

customElements.define('search-form', SearchForm);
